import {
	InteractiveLayer,
  DataTableLocal as DataTable,
  DataColumn,
  DataRow,
  Feature,
  LineSegment,
  PointGeometry,
  PaletteFactory, 
  PolylineGeometry,
  PolygonGeometry,
  AnnotationGeometry,
  NonHierarchicalDistanceBasedClusteringAlgorithm,
  ThemeSetGroup,
  ThemeSet,
  FilterDataColumn,
  StringFilter,
  NumericFilter,
  Style,
  ThematicSize as Size,
  Color,
  SymbolPointSymbolizer,
  ImagePointSymbolizer,
  PolylineSymbolizer,
  PolygonSymbolizer,
  AnnotationSymbolizer,
  ThemeByIndividualValues,
  ThemeByGradientOfValues,
  ThemeByRangesOfValues,
  HeatMapTheme,
  ColorPalette,
  HeatMapPaletteEnum,
  SymbolOverlayTheme,
  ThemeElement,
  RepresentationEnum,
  CoordinateSystem,
  PieChartOverlayTheme,
  BarChartOverlayTheme,
  IndividualValueScheme,
  RangeScheme,
  RangeOfValue,
  ThematicSchemeManager,
  Renderer,
  RGBA,
  RollOverFill,
  RollOverOuterGlow,
  RollOverStroke,
  LayerLabelProperties,
  StyleLabelProperties,
  Proj4Projection,
  FontLibrary,
  VectorLayerOptions,
  Util,
  DBxEvent,
  GraphicFilterOuterGlow,
  GraphicFilterInnerGlow,
  GraphicFilterDropShadow
} from "cartovista";
import FlowThemeSet from '../panels/flow/FlowThemeSet';
import ClusterAlgorithmExtend from "../layers/ClusterAlgorithmExtend";
import WMSLayerExtend from "./WMSLayerExtend";//keep
import {queryLayer, queryEsriLayer, queryCartovistaLayer} from "./ServerRequests";

    export function parseConfig(config, obj) {
        var config = _.cloneDeep(config);
        _.forEach(config, function(value, key) {
            switch (Object.prototype.toString.call(value)) {
                case "[object Array]":
                case "[object Object]":
                    config[key] = parseConfig(value, obj);
                    break;
                case "[object Function]":
                    config[key] = value(obj);
                    break;
                case "[object String]":
                    if (value.match(/{{(.*?)}}/g)) {
                        config[key] = _parseConfigValue(value, obj);
                    } else {
                        config[key] = value;
                    }
                    break;
                default:
                    config[key] = value;
            };
        });
        return config;
    };

    function _parseConfigValue(value, obj) {
        var parts = value.split(/{{(.*?)}}/g).filter(Boolean);
        if (parts.length == 1) {
            //keeps the type of the return value when single part
            return _replaceUsingWildCard(parts[0], value, obj);
        } else {
            //type of the return value would be a string when multiple parts
            return _.map(parts, function(part) {
                if (value.indexOf("{{" + part + "}}") > -1) {
                    return _replaceUsingWildCard(part, value, obj);
                } else {
                    return part;
                }
            }).join("");
        }
    };

    function _replaceUsingWildCard(wildCard, value, obj) {
        if (typeof obj[wildCard] != "undefined") {
            return obj[wildCard];
        } else {
            switch(wildCard) {
                case "$UNIQUE$":
                    return _.uniqueId();
                case "$UUID$":
                    return Util.uuid();
                default:
                    console.error(wildCard)
                    throw new Error("CvUtils._replaceUsingWildCard() - wildCard: " + wildCard + " from value: " + value + " not found in object.");
            };
        }
    };

    export function createLayer(layerConfig) {
        if (typeof layerConfig.UNIQUE_LAYER_ID != "undefined") layerConfig.UNIQUE_LAYER_ID = _.uniqueId(layerConfig.UNIQUE_LAYER_ID);
        if(layerConfig.LOADING_MODE == "ESRI" || layerConfig.LOADING_MODE == "CARTOVISTA"){
            var projection = new Proj4Projection("EPSG:3857");
            var c = new CoordinateSystem('Spherical Mercator', projection);
            var vectorOptions = new VectorLayerOptions("vectorSourceTypeLocal", layerConfig.LAYER_PROPERTIES.FEATURE_ID_DATACOLUMN, layerConfig.LAYER_PROPERTIES.STYLE_DATACOLUMN, [c], null, layerConfig.LAYER_PROPERTIES.ROTATION_DATACOLUMN);
            vectorOptions.currentMapCoordinateSystem = c;
        }
        var layer = new InteractiveLayer(typeof layerConfig.UNIQUE_LAYER_ID != "undefined" ? layerConfig.UNIQUE_LAYER_ID : layerConfig.LAYER_ID, vectorOptions ? vectorOptions : null);
        layer.layerType = layerConfig.LAYER_TYPE;
        if (!layerConfig.LAYER_PROPERTIES.UNIQUE_FEATURES_STYLES) {
            _.forEach(layerConfig.STYLES, function(styleConfig) {
                var style = createStyle(styleConfig);
                layer.addStyle(style);
            });
        }
        if(layerConfig.LOADING_MODE == "ESRI" || layerConfig.LOADING_MODE == "CARTOVISTA"){
            var dataTable = layer.attributesDataTable;
            var dataColumns = createDataColumns(layerConfig);
            dataTable.addDataColumns(dataColumns);
        } else{
            var dataTable = new DataTable(layerConfig.DATATABLE_ID);
            var dataColumns = createDataColumns(layerConfig);
            dataTable.addDataColumns(dataColumns);
            layer.dataElementRoot.addDataElement(dataTable);
        }
        layer = initLayerProperties(layer, dataTable, layerConfig.LAYER_PROPERTIES);
        if(layerConfig.JOIN) _.forEach(layerConfig.JOIN, function(joinConfig){joinDataTable(layer, layerConfig, joinConfig)});
        return layer;
    };

    export function joinDataTable(layer, layerConfig, joinConfig) {
        var dataTable = new DataTable(joinConfig.DATATABLE_ID, joinConfig.SOURCE, joinConfig.FORMAT);
        dataTable.name = typeof joinConfig.NAME != "undefined" ? joinConfig.NAME : joinConfig.DATATABLE_ID;
        var dataColumns = createDataColumns(joinConfig);
        dataTable.addDataColumns(dataColumns);
        layer.dataElementRoot.addDataElement(dataTable);
        _modifyLayerProperties(layer, dataTable, layerConfig.LAYER_PROPERTIES);
        return new Promise(function(resolve, reject) {
            layer.getSimpleFeatures(null, function(result){
                if(result.features.length == 0){
                    layer.addOneTimeEventListener(layer.EVENTS.FEATURES_ADDED, function(){ layer.getSimpleFeatures(null, resolve, this, false); }, this);
                } else{
                    resolve(result);
                }
            }, this, false);
        }).then(function(result) {
            dataTable.load(function(success){
                ///remove datarows from the join with no associated feature
                var linkingIds = _.map(layer.featureIdDataColumn.dataTable._dataRows, "linkingId");
                var unwantedDataRows = _.reject(dataTable._dataRows, function(dataRow){
                    return _.includes(linkingIds, dataRow.linkingId);
                });
                dataTable.removeDataRows(_.map(unwantedDataRows, "linkingId"));
                //style datacolum is from join
                if(layer.styleDataColumn && layer.styleDataColumn.dataTable == dataTable){
                    layer.createDataQuery([layer.styleDataColumn], _.map(result.features, "id")).execute(function(dataQueryResult){
                        _.forEach(result.features, function(feature, idx){
                            var style = layer.getStyle(dataQueryResult.values[layer.styleDataColumn.dataTable.id][layer.styleDataColumn.id][idx]);
                            if(style){
                                feature.style = style;
                            }
                        });
                        //remove defaultStyle if empty
                        var defaultStyle = layer.getDefaultStyle(layer.layerType);
                        layer.getStyleclassItemCount(defaultStyle, function(styleCount){
                            if(styleCount.count == 0){
                                layer.removeStyle(styleCount.style.id);   
                            }
                        }, this)
                    }, this);
                }
            });
        });
    };

    function _replaceDataColumns(startColumns, dataTable, dataColumnsIds) {
        var newColumns = dataTable.getDataColumns(dataColumnsIds);
        if(Array.isArray(startColumns)){
            _.forEach(startColumns, function(dataColumn, idx){
                if(!dataColumn && newColumns[idx]){
                    startColumns[idx] = newColumns[idx];
                }
            });
            return startColumns;
        } else{
            if(!startColumns && newColumns[0]){
                startColumns = newColumns[0];
            } else if(startColumns && newColumns[0] && startColumns != newColumns[0]){
                startColumns = newColumns[0];
            }
            return startColumns;
        }
    };

    function _modifyLayerProperties(layer, dataTable, layerConfig) {
        if (typeof layerConfig.DATAVIEW_DATACOLUMNS != "undefined") layer.dataViewDataColumns = _replaceDataColumns(layer.dataViewDataColumns, dataTable, layerConfig.DATAVIEW_DATACOLUMNS);
        if (typeof layerConfig.DATATIP_DATACOLUMNS != "undefined") layer.dataTipDataColumns = _replaceDataColumns(layer.dataTipDataColumns, dataTable, layerConfig.DATATIP_DATACOLUMNS);
        if (typeof layerConfig.FEATURE_NAME_DATACOLUMN != "undefined") layer.featureNameDataColumn = _replaceDataColumns(layer.featureNameDataColumn, dataTable, layerConfig.FEATURE_NAME_DATACOLUMN);
        if (typeof layerConfig.HYPERLINK_DATACOLUMN != "undefined") layer.hyperlinkDataColumn = _replaceDataColumns(layer.hyperlinkDataColumn, dataTable, layerConfig.HYPERLINK_DATACOLUMN);
        if (typeof layerConfig.INFOVIEW_DATACOLUMNS != "undefined") layer.infoViewDataColumns = _replaceDataColumns(layer.infoViewDataColumns, dataTable, layerConfig.INFOVIEW_DATACOLUMNS);
        if (typeof layerConfig.LABEL_DATACOLUMN != "undefined") layer.labelDataColumn = _replaceDataColumns(layer.labelDataColumn, dataTable, layerConfig.LABEL_DATACOLUMN);
        if (typeof layerConfig.SEARCHABLE_DATACOLUMNS != "undefined") layer.searchableDataColumns = _replaceDataColumns(layer.searchableDataColumns, dataTable, layerConfig.SEARCHABLE_DATACOLUMNS);
        if (typeof layerConfig.STYLE_DATACOLUMN != "undefined") layer.styleDataColumn = _replaceDataColumns(layer.styleDataColumn, dataTable, layerConfig.STYLE_DATACOLUMN);
    };

    export function createDataColumns(layerConfig) {
        return _.map(layerConfig.FIELDS, function(fieldConfig) {
            var dataColumn = new DataColumn(fieldConfig.ID, fieldConfig.DATA_TYPE);
            if (typeof fieldConfig.AGGREGATION_METHOD != "undefined") dataColumn.aggregationMethod = fieldConfig.AGGREGATION_METHOD;
            if (typeof fieldConfig.DECIMAL_PLACES != "undefined") dataColumn.decimalPlaces = fieldConfig.DECIMAL_PLACES;
            if (typeof fieldConfig.DESCRIPTION != "undefined") dataColumn.description = fieldConfig.DESCRIPTION;
            if (typeof fieldConfig.MAPPABLE != "undefined") dataColumn.mappable = fieldConfig.MAPPABLE;
            if (typeof fieldConfig.NAME != "undefined") dataColumn.name = fieldConfig.NAME;
            if (typeof fieldConfig.NOT_AVAILABLE_VALUE != "undefined") dataColumn.notAvailableValue = fieldConfig.NOT_AVAILABLE_VALUE;
            if (typeof fieldConfig.TIME_STAMP != "undefined") dataColumn.timeStamp = fieldConfig.TIME_STAMP;
            if (typeof fieldConfig.TIME_STAMP_ACCURACY != "undefined") dataColumn.timeStampAccuracy = fieldConfig.TIME_STAMP_ACCURACY;
            if (typeof fieldConfig.UNITS != "undefined") dataColumn.units = fieldConfig.UNITS;
            return dataColumn;
        });
    };

    export function initLayerProperties(layer, dataTable, layerPropertiesConfig) {
        if (typeof layerPropertiesConfig.ALPHA != "undefined") layer.alpha = layerPropertiesConfig.ALPHA;
        if (typeof layerPropertiesConfig.BLEND_MODE != "undefined") layer.blendMode = layerPropertiesConfig.BLEND_MODE;
        if (typeof layerPropertiesConfig.CLUSTERING_ACTIVATED != "undefined") layer.clusteringActivated = layerPropertiesConfig.CLUSTERING_ACTIVATED ? true : false;
        if (layerPropertiesConfig.CLUSTERING_ENABLED) {
            layer.clusteringEnabled = true;
            layer.vectorSource.clusteringAlgorithm = new NonHierarchicalDistanceBasedClusteringAlgorithm(window.cartovista.externalInterface.map, layerPropertiesConfig.CLUSTER_SIZE);
        }
        if (typeof layerPropertiesConfig.CLUSTERING_FORCE_CLUSTER_SCALE != "undefined") layer.clusteringForceClusterScale = layerPropertiesConfig.CLUSTERING_FORCE_CLUSTER_SCALE;
        if (typeof layerPropertiesConfig.DATATIP_DATACOLUMNS != "undefined") layer.dataTipDataColumns = dataTable.getDataColumns(layerPropertiesConfig.DATATIP_DATACOLUMNS);
        if (typeof layerPropertiesConfig.DATATIP_DATACOLUMNS_DISPLAY_MODE != "undefined") layer.dataTipDataColumnsDisplayMode = layerPropertiesConfig.DATATIP_DATACOLUMNS_DISPLAY_MODE;
        if (typeof layerPropertiesConfig.DATATIP_FUNCTION != "undefined") layer.dataTipFunction = layerPropertiesConfig.DATATIP_FUNCTION;
        if (typeof layerPropertiesConfig.DATAVIEW_DATACOLUMNS != "undefined") layer.dataViewDataColumns = dataTable.getDataColumns(layerPropertiesConfig.DATAVIEW_DATACOLUMNS);
        if (typeof layerPropertiesConfig.DATAVIEW_DATACOLUMNS_DISPLAY_MODE != "undefined") layer.dataViewDataColumnsDisplayMode = layerPropertiesConfig.DATAVIEW_DATACOLUMNS_DISPLAY_MODE;
        if (typeof layerPropertiesConfig.FEATURE_ID_DATACOLUMN != "undefined") layer.featureIdDataColumn =  dataTable.getDataColumns(layerPropertiesConfig.FEATURE_ID_DATACOLUMN)[0];
        if (typeof layerPropertiesConfig.FEATURE_NAME_DATACOLUMN != "undefined") layer.featureNameDataColumn = dataTable.getDataColumns(layerPropertiesConfig.FEATURE_NAME_DATACOLUMN)[0];
        if (typeof layerPropertiesConfig.HYPERLINK_DATACOLUMN != "undefined") layer.hyperlinkDataColumn = dataTable.getDataColumns(layerPropertiesConfig.HYPERLINK_DATACOLUMN)[0];
        if (typeof layerPropertiesConfig.HYPERLINK_TARGET_TYPE != "undefined") layer.hyperlinkTargetType = layerPropertiesConfig.HYPERLINK_TARGET_TYPE;
        if (typeof layerPropertiesConfig.INFOVIEW_DATACOLUMNS != "undefined") layer.infoViewDataColumns = dataTable.getDataColumns(layerPropertiesConfig.INFOVIEW_DATACOLUMNS);
        if (typeof layerPropertiesConfig.INFOVIEW_DATACOLUMN_DISPLAY_MODE != "undefined") layer.infoViewDataColumnsDisplayMode = layerPropertiesConfig.INFOVIEW_DATACOLUMN_DISPLAY_MODE;
        if (typeof layerPropertiesConfig.IS_VISIBLE_IN_LAYER_CONTROL != "undefined") layer.isVisibleInLayerControl = layerPropertiesConfig.IS_VISIBLE_IN_LAYER_CONTROL ? true : false;
        if (typeof layerPropertiesConfig.IS_VISIBLE_IN_LEGEND != "undefined") layer.isVisibleInLegend = layerPropertiesConfig.IS_VISIBLE_IN_LEGEND ? true : false;
        if (typeof layerPropertiesConfig.IS_VISIBLE_IN_LEGEND_EXTENT != "undefined") layer.IsVisibleInLegendExtent = layerPropertiesConfig.IS_VISIBLE_IN_LEGEND_EXTENT ? true : false;
        if (typeof layerPropertiesConfig.IS_ZOOM_LAYERED != "undefined") layer.isZoomLayered = layerPropertiesConfig.IS_ZOOM_LAYERED ? true : false;
        if (typeof layerPropertiesConfig.LABEL_DATACOLUMN != "undefined") layer.labelDataColumn = dataTable.getDataColumns(layerPropertiesConfig.LABEL_DATACOLUMN)[0];
        if (typeof layerPropertiesConfig.LABEL_PROPERTIES != "undefined") layer.layerLabelProperties = _initLayerLabelProperties(layerPropertiesConfig.LABEL_PROPERTIES);
        if (typeof layerPropertiesConfig.MAX_FEATURES_FOR_ROLLOVER != "undefined") layer.MAX_FEATURES_FOR_ROLLOVER = layerPropertiesConfig.MAX_FEATURES_FOR_ROLLOVER;
        if (typeof layerPropertiesConfig.MAX_RECORDS_FOR_SELECTION != "undefined") layer.maxRecordsForSelection = layerPropertiesConfig.MAX_RECORDS_FOR_SELECTION;
        if (typeof layerPropertiesConfig.MAX_SCALE != "undefined") layer.maxScale = layerPropertiesConfig.MAX_SCALE;
        if (typeof layerPropertiesConfig.MIN_SCALE != "undefined") layer.minScale = layerPropertiesConfig.MIN_SCALE;
        if (typeof layerPropertiesConfig.METADATA != "undefined") layer.metadata = layerPropertiesConfig.METADATA;
        if (typeof layerPropertiesConfig.NAME != "undefined") layer.name = layerPropertiesConfig.NAME;
        if (typeof layerPropertiesConfig.ROLL_OVER_EFFECTS != "undefined") layer.rollOverEffects = _initLayerRollOverEffects(layerPropertiesConfig.ROLL_OVER_EFFECTS);
        if (typeof layerPropertiesConfig.SEARCHABLE_DATACOLUMNS != "undefined") layer.searchableDataColumns = dataTable.getDataColumns(layerPropertiesConfig.SEARCHABLE_DATACOLUMNS);
        if (typeof layerPropertiesConfig.SEARCH_RADIUS != "undefined") layer.searchRadius = layerPropertiesConfig.SEARCH_RADIUS;
        if (typeof layerPropertiesConfig.SHOW_ATTRIBUTES_DATATABLE != "undefined") layer.showAttributesDataTable = layerPropertiesConfig.SHOW_ATTRIBUTES_DATATABLE ? true : false;
        if (typeof layerPropertiesConfig.SHOW_DATATIPS != "undefined") layer.showDataTips = layerPropertiesConfig.SHOW_DATATIPS ? true : false;
        if (typeof layerPropertiesConfig.SHOW_STYLES_IN_LAYER_CONTROL != "undefined") layer.showStylesInLayerControl = layerPropertiesConfig.SHOW_STYLES_IN_LAYER_CONTROL;
        if (typeof layerPropertiesConfig.STYLE_DATACOLUMN != "undefined") layer.styleDataColumn = dataTable.getDataColumns(layerPropertiesConfig.STYLE_DATACOLUMN)[0];
        if (typeof layerPropertiesConfig.VISIBLE != "undefined") layer.visible = layerPropertiesConfig.VISIBLE ? true : false;
        if (typeof layerPropertiesConfig.ZOOM_ON_FEATURE_SCALE != "undefined") layer.zoomOnFeatureScale = layerPropertiesConfig.ZOOM_ON_FEATURE_SCALE;
        return layer;
    };

    function _initLayerLabelProperties(labelConfig) {
        var layerLabelProperties = new LayerLabelProperties();
        if (typeof labelConfig.ALLOW_LABEL_DUPLICATES != "undefined") layerLabelProperties.allowLabelDuplicates = labelConfig.ALLOW_LABEL_DUPLICATES ? true : false;
        if (typeof labelConfig.ALLOW_LABEL_OVERLAP != "undefined") layerLabelProperties.allowLabelOverlap = labelConfig.ALLOW_LABEL_OVERLAP ? true : false;
        if (typeof labelConfig.IS_ZOOM_LAYERED != "undefined") layerLabelProperties.isZoomLayered = labelConfig.IS_ZOOM_LAYERED ? true : false;
        if (typeof labelConfig.LABEL_TYPE != "undefined") layerLabelProperties.labelType = labelConfig.LABEL_TYPE;
        if (typeof labelConfig.LEADER_COLOR != "undefined") layerLabelProperties.leaderColor = labelConfig.LEADER_COLOR;
        if (typeof labelConfig.LEADER_GRID_STEP != "undefined") layerLabelProperties.leaderGridStep = labelConfig.LEADER_GRID_STEP;
        if (typeof labelConfig.LEADER_LINES != "undefined") layerLabelProperties.leaderLines = labelConfig.LEADER_LINES ? true : false;
        if (typeof labelConfig.LEADER_MAX_DISTANCE != "undefined") layerLabelProperties.leaderMaxDistance = labelConfig.LEADER_MAX_DISTANCE;
        if (typeof labelConfig.MAX_SCALE != "undefined") layerLabelProperties.maxScale = labelConfig.MAX_SCALE;
        if (typeof labelConfig.MIN_SCALE != "undefined") layerLabelProperties.minScale = labelConfig.MIN_SCALE;
        if (typeof labelConfig.OFFSET_X != "undefined") layerLabelProperties.offsetX = labelConfig.OFFSET_X;
        if (typeof labelConfig.OFFSET_Y != "undefined") layerLabelProperties.offsetY = labelConfig.OFFSET_Y;
        if (typeof labelConfig.POSITION != "undefined") layerLabelProperties.position = labelConfig.POSITION;
        if (typeof labelConfig.PRIORITY != "undefined") layerLabelProperties.priority = labelConfig.PRIORITY;
        if (typeof labelConfig.ROTATION != "undefined") layerLabelProperties.rotation = labelConfig.ROTATION;
        if (typeof labelConfig.VISIBLE != "undefined") layerLabelProperties.visible = labelConfig.VISIBLE ? true : false;
        return layerLabelProperties;
    };

    export function initLayerGraphicFilterEffects(graphicFilterEffectsConfig) {
        return _.map(graphicFilterEffectsConfig, function(graphicFilterEffectConfig) {
            switch (graphicFilterEffectConfig.TYPE) {
                case "GraphicFilterOuterGlow":
                    var graphicFilterEffect = new GraphicFilterOuterGlow();
                    if (typeof graphicFilterEffectConfig.COLOR != "undefined") graphicFilterEffect.color = _createNewRGBA(graphicFilterEffectConfig.COLOR);
                    if (typeof graphicFilterEffectConfig.ALPHA != "undefined") graphicFilterEffect.alpha = graphicFilterEffectConfig.ALPHA;
                    if (typeof graphicFilterEffectConfig.BLUR_X != "undefined") graphicFilterEffect.blurX = graphicFilterEffectConfig.BLUR_X;
                    if (typeof graphicFilterEffectConfig.BLUR_Y != "undefined") graphicFilterEffect.blurY = graphicFilterEffectConfig.BLUR_Y;
                    if (typeof graphicFilterEffectConfig.KNOCKOUT != "undefined") graphicFilterEffect.knockout = graphicFilterEffectConfig.KNOCKOUT;
                    if (typeof graphicFilterEffectConfig.STRENGTH != "undefined") graphicFilterEffect.strength = graphicFilterEffectConfig.STRENGTH;
                    return graphicFilterEffect;
                case "GraphicFilterInnerGlow":
                    var graphicFilterEffect = new GraphicFilterInnerGlow();
                    if (typeof graphicFilterEffectConfig.COLOR != "undefined") graphicFilterEffect.color = _createNewRGBA(graphicFilterEffectConfig.COLOR);
                    if (typeof graphicFilterEffectConfig.ALPHA != "undefined") graphicFilterEffect.alpha = graphicFilterEffectConfig.ALPHA;
                    if (typeof graphicFilterEffectConfig.BLUR_X != "undefined") graphicFilterEffect.blurX = graphicFilterEffectConfig.BLUR_X;
                    if (typeof graphicFilterEffectConfig.BLUR_Y != "undefined") graphicFilterEffect.blurY = graphicFilterEffectConfig.BLUR_Y;
                    if (typeof graphicFilterEffectConfig.STRENGTH != "undefined") graphicFilterEffect.strength = graphicFilterEffectConfig.STRENGTH;
                    return graphicFilterEffect;
                case "GraphicFilterDropShadow":
                    var graphicFilterEffect = new GraphicFilterDropShadow();
                    if (typeof graphicFilterEffectConfig.COLOR != "undefined") graphicFilterEffect.color = _createNewRGBA(graphicFilterEffectConfig.COLOR);
                    if (typeof graphicFilterEffectConfig.ALPHA != "undefined") graphicFilterEffect.alpha = graphicFilterEffectConfig.ALPHA;
                    if (typeof graphicFilterEffectConfig.BLUR_X != "undefined") graphicFilterEffect.blurX = graphicFilterEffectConfig.BLUR_X;
                    if (typeof graphicFilterEffectConfig.BLUR_Y != "undefined") graphicFilterEffect.blurY = graphicFilterEffectConfig.BLUR_Y;
                    if (typeof graphicFilterEffectConfig.DISTANCE != "undefined") graphicFilterEffect.distance = graphicFilterEffectConfig.DISTANCE;
                    if (typeof graphicFilterEffectConfig.ANGLE != "undefined") graphicFilterEffect.angle = graphicFilterEffectConfig.ANGLE;
                    if (typeof graphicFilterEffectConfig.KNOCKOUT != "undefined") graphicFilterEffect.knockout = graphicFilterEffectConfig.KNOCKOUT;
                    if (typeof graphicFilterEffectConfig.STRENGTH != "undefined") graphicFilterEffect.strength = graphicFilterEffectConfig.STRENGTH;
                    return graphicFilterEffect;
                default:
                    throw new Error("CvUtils._initLayerGraphicFilterEffects() - graphicFilterEffectConfig.TYPE :" + graphicFilterEffectConfig.TYPE + " is invalid.");
            };
        });
    };

    function _initLayerRollOverEffects(rollOverEffectsConfig) {
        return _.map(rollOverEffectsConfig, function(rollOverEffectConfig) {
            switch (rollOverEffectConfig.TYPE) {
                case "RollOverFill":
                    var rollOverEffect = new RollOverFill();
                    if (typeof rollOverEffectConfig.FILL_COLOR_1 != "undefined") rollOverEffect.fillColor1 = _createNewRGBA(rollOverEffectConfig.FILL_COLOR_1);
                    if (typeof rollOverEffectConfig.FILL_COLOR_2 != "undefined") rollOverEffect.fillColor2 = _createNewRGBA(rollOverEffectConfig.FILL_COLOR_2);
                    if (typeof rollOverEffectConfig.FILL_PATTERN != "undefined") rollOverEffect.fillPattern = rollOverEffectConfig.FILL_PATTERN;
                    if (typeof rollOverEffectConfig.FILL_STYLE != "undefined") rollOverEffect.fillStyle = rollOverEffectConfig.FILL_STYLE;
                    return rollOverEffect;
                case "RollOverOuterGlow":
                    var rollOverEffect = new RollOverOuterGlow();
                    if (typeof rollOverEffectConfig.COLOR != "undefined") rollOverEffect.color = _createNewRGBA(rollOverEffectConfig.COLOR);
                    if (typeof rollOverEffectConfig.SIZE != "undefined") rollOverEffect.size = rollOverEffectConfig.SIZE;
                    return rollOverEffect;
                case "RollOverStroke":
                    var rollOverEffect = new RollOverStroke();
                    if (typeof rollOverEffectConfig.COLOR != "undefined") rollOverEffect.color = _createNewRGBA(rollOverEffectConfig.COLOR);
                    if (typeof rollOverEffectConfig.SIZE != "undefined") rollOverEffect.size = rollOverEffectConfig.SIZE;
                    return rollOverEffect;
                default:
                    throw new Error("CvUtils._initLayerRollOverEffect() - rollOverEffectConfig.TYPE :" + rollOverEffectConfig.TYPE + " is invalid.");
            };
        });
    };

    export function createStyle(styleConfig) {
        var style = new Style(styleConfig.ID, styleConfig.NAME);
        //if (typeof styleConfig.NAME != "undefined") style.name = styleConfig.NAME;
        if (typeof styleConfig.STYLE_LABEL_PROPERTIES != "undefined") style.styleLabelProperties = _createStyleLabelProperties(styleConfig.STYLE_LABEL_PROPERTIES);
        //styleConfig.value property is used for multi styles layers
        if (typeof styleConfig.VALUE != "undefined") style.value = styleConfig.VALUE;
        _.forEach(styleConfig.SYMBOLIZERS, function(symbolizerConfig) {
            style.addSymbolizer(_createSymbolizer(symbolizerConfig));
        });
        return style;
    };

    function _createNewRGBA(rgba) {
        if (rgba != "RANDOM") {
            return new RGBA(rgba);
        } else {
            return new RGBA(_.random(0,255), _.random(0,255), _.random(0,255), 1);
        }
    };

    function _createSymbolizer(symbolizerConfig) {
        switch (symbolizerConfig.SYMBOLIZER_TYPE) {
            case "SymbolPointSymbolizer":
                return _createSymbolPointSymbolizer(symbolizerConfig);
            case "ImagePointSymbolizer":
                return _createImagePointSymbolizer(symbolizerConfig);
            case "PolylineSymbolizer":
                return _createPolylineSymbolizer(symbolizerConfig);
            case "PolygonSymbolizer":
                return _createPolygonSymbolizer(symbolizerConfig);
            case "AnnotationSymbolizer":
                return _createAnnotationSymbolizer(symbolizerConfig);
            default:
                throw new Error("CvUtils._createSymbolizer - symbolizerConfig.SYMBOLIZER_TYPE : " + symbolizerConfig.SYMBOLIZER_TYPE + " is invalid.");
        };
    };

    function _createSymbolPointSymbolizer(symbolizerConfig) {
        var symbolizer = new SymbolPointSymbolizer(symbolizerConfig.Z_INDEX ? symbolizerConfig.Z_INDEX : 0);
        if (typeof symbolizerConfig.ALPHA != "undefined") symbolizer.alpha = symbolizerConfig.ALPHA;
        if (typeof symbolizerConfig.COLOR != "undefined") symbolizer.color = _createNewRGBA(symbolizerConfig.COLOR);
        if (typeof symbolizerConfig.DROP_SHADOW_COLOR != "undefined") symbolizer.dropShadowColor = _createNewRGBA(symbolizerConfig.DROP_SHADOW_COLOR);
        if (typeof symbolizerConfig.FONT_NAME != "undefined" && typeof symbolizerConfig.FONT_FILE_SOURCE != "undefined") {
            FontLibrary.addFont(symbolizerConfig.FONT_NAME, symbolizerConfig.FONT_FILE_SOURCE);
            symbolizer.fontName = symbolizerConfig.FONT_NAME;
        }
        if (typeof symbolizerConfig.HALO_COLOR != "undefined") symbolizer.haloColor = _createNewRGBA(symbolizerConfig.HALO_COLOR);
        if (typeof symbolizerConfig.HAS_DROP_SHADOW != "undefined") symbolizer.hasDropShadow = symbolizerConfig.HAS_DROP_SHADOW ? true : false;
        if (typeof symbolizerConfig.HAS_HALO != "undefined") symbolizer.hasHalo = symbolizerConfig.HAS_HALO ? true : false;
        if (typeof symbolizerConfig.OFFSET_X != "undefined") symbolizer.offsetX = symbolizerConfig.OFFSET_X;
        if (typeof symbolizerConfig.OFFSET_Y != "undefined") symbolizer.offsetY = symbolizerConfig.OFFSET_Y;
        if (typeof symbolizerConfig.ROTATION_ANGLE != "undefined") symbolizer.rotationAngle = symbolizerConfig.ROTATION_ANGLE;
        if (typeof symbolizerConfig.SIZE != "undefined") symbolizer.size = symbolizerConfig.SIZE;
        if (typeof symbolizerConfig.SYMBOL_CHAR != "undefined") symbolizer.symbolChar = symbolizerConfig.SYMBOL_CHAR;
        return symbolizer;
    };

    function _createImagePointSymbolizer(symbolizerConfig) {
        var symbolizer = new ImagePointSymbolizer(symbolizerConfig.Z_INDEX ? symbolizerConfig.Z_INDEX : 0);
        if (typeof symbolizerConfig.ALPHA != "undefined") symbolizer.alpha = symbolizerConfig.ALPHA;
        if (typeof symbolizerConfig.OFFSET_X != "undefined") symbolizer.offsetX = symbolizerConfig.OFFSET_X;
        if (typeof symbolizerConfig.OFFSET_Y != "undefined") symbolizer.offsetY = symbolizerConfig.OFFSET_Y;
        if (typeof symbolizerConfig.ROTATION_ANGLE != "undefined") symbolizer.rotationAngle = symbolizerConfig.ROTATION_ANGLE;
        if (typeof symbolizerConfig.SRC != "undefined") symbolizer.src = symbolizerConfig.SRC;
        if (typeof symbolizerConfig.SRC_ROLLOVER != "undefined") symbolizer.srcRollover = symbolizerConfig.SRC_ROLLOVER;
        if (typeof symbolizerConfig.SRC_STROKE != "undefined") symbolizer.srcStroke = symbolizerConfig.SRC_STROKE;
        return symbolizer;
    };

    function _createPolylineSymbolizer(symbolizerConfig) {
        var symbolizer = new PolylineSymbolizer(symbolizerConfig.Z_INDEX ? symbolizerConfig.Z_INDEX : 0);
        if (typeof symbolizerConfig.ALPHA != "undefined") symbolizer.alpha = symbolizerConfig.ALPHA;
        if (typeof symbolizerConfig.STROKE_COLOR != "undefined") symbolizer.strokeColor = _createNewRGBA(symbolizerConfig.STROKE_COLOR);
        if (typeof symbolizerConfig.STROKE_DASH_ARRAY != "undefined") symbolizer.strokeDashArray = symbolizerConfig.STROKE_DASH_ARRAY;
        if (typeof symbolizerConfig.STROKE_LINE_CAP != "undefined") symbolizer.strokeLineCap = symbolizerConfig.STROKE_LINE_CAP;
        if (typeof symbolizerConfig.STROKE_LINE_JOIN != "undefined") symbolizer.strokeLineJoin = symbolizerConfig.STROKE_LINE_JOIN;
        if (typeof symbolizerConfig.STROKE_PATTERN != "undefined") symbolizer.strokePattern = symbolizerConfig.STROKE_PATTERN;
        if (typeof symbolizerConfig.STROKE_STYLE != "undefined") symbolizer.strokeStyle = symbolizerConfig.STROKE_STYLE;
        if (typeof symbolizerConfig.STROKE_WIDTH != "undefined") symbolizer.strokeWidth = symbolizerConfig.STROKE_WIDTH;
        return symbolizer
    };

    function _createPolygonSymbolizer(symbolizerConfig) {
        var symbolizer = new PolygonSymbolizer(symbolizerConfig.Z_INDEX ? symbolizerConfig.Z_INDEX : 0);
        if (typeof symbolizerConfig.ALPHA != "undefined") symbolizer.alpha = symbolizerConfig.ALPHA;
        if (typeof symbolizerConfig.FILL_ALPHA != "undefined") symbolizer.fillAlpha = symbolizerConfig.FILL_ALPHA;
        if (typeof symbolizerConfig.FILL_COLOR_1 != "undefined") symbolizer.fillColor1 = _createNewRGBA(symbolizerConfig.FILL_COLOR_1);
        if (typeof symbolizerConfig.FILL_COLOR_2 != "undefined") symbolizer.fillColor2 = _createNewRGBA(symbolizerConfig.FILL_COLOR_2);
        if (symbolizerConfig.FILL_PATTERN) symbolizer.fillPattern = symbolizerConfig.FILL_PATTERN;
        if (typeof symbolizerConfig.FILL_STYLE != "undefined") symbolizer.fillStyle = symbolizerConfig.FILL_STYLE;
        if (typeof symbolizerConfig.STROKE_COLOR != "undefined") symbolizer.strokeColor = _createNewRGBA(symbolizerConfig.STROKE_COLOR);
        if (typeof symbolizerConfig.STROKE_DASH_ARRAY != "undefined") symbolizer.strokeDashArray = symbolizerConfig.STROKE_DASH_ARRAY;
        if (typeof symbolizerConfig.STROKE_LINE_CAP != "undefined") symbolizer.strokeLineCap = symbolizerConfig.STROKE_LINE_CAP;
        if (typeof symbolizerConfig.STROKE_LINE_JOIN != "undefined") symbolizer.strokeLineJoin = symbolizerConfig.STROKE_LINE_JOIN;
        if (typeof symbolizerConfig.STROKE_PATTERN != "undefined") symbolizer.strokePattern = symbolizerConfig.STROKE_PATTERN;
        if (typeof symbolizerConfig.STROKE_STYLE != "undefined") symbolizer.strokeStyle = symbolizerConfig.STROKE_STYLE;
        if (typeof symbolizerConfig.STROKE_WIDTH != "undefined") symbolizer.strokeWidth = symbolizerConfig.STROKE_WIDTH;
        return symbolizer;
    };

    function _createAnnotationSymbolizer(symbolizerConfig) {
        var symbolizer = new AnnotationSymbolizer(symbolizerConfig.Z_INDEX ? symbolizerConfig.Z_INDEX : 0);
        if (typeof symbolizerConfig.BOLD != "undefined") symbolizer.bold = symbolizerConfig.BOLD ? true : false;
        if (typeof symbolizerConfig.COLOR != "undefined") symbolizer.color = _createNewRGBA(symbolizerConfig.COLOR);
        if (typeof symbolizerConfig.DROP_SHADOW_COLOR != "undefined") symbolizer.dropShadowColor = _createNewRGBA(symbolizerConfig.DROP_SHADOW_COLOR);
        if (typeof symbolizerConfig.FILL_ALPHA != "undefined") symbolizer.fillAlpha = symbolizerConfig.FILL_ALPHA;
        if (typeof symbolizerConfig.FILL_COLOR_1 != "undefined") symbolizer.fillColor1 = _createNewRGBA(symbolizerConfig.FILL_COLOR_1);
        if (typeof symbolizerConfig.FILL_STYLE != "undefined") symbolizer.fillStyle = symbolizerConfig.FILL_STYLE;
        if (typeof symbolizerConfig.FONT_NAME != "undefined" && typeof symbolizerConfig.FONT_FILE_SOURCE != "undefined") {
            FontLibrary.addFont(symbolizerConfig.FONT_NAME, symbolizerConfig.FONT_FILE_SOURCE);
            symbolizer.fontName = symbolizerConfig.FONT_NAME;
        }
        if (typeof symbolizerConfig.HALO_COLOR != "undefined") symbolizer.haloColor = _createNewRGBA(symbolizerConfig.HALO_COLOR);
        if (typeof symbolizerConfig.HAS_DROP_SHADOW != "undefined") symbolizer.hasDropShadow = symbolizerConfig.HAS_DROP_SHADOW ? true : false;
        if (typeof symbolizerConfig.HAS_HALO != "undefined") symbolizer.hasHalo = symbolizerConfig.HAS_HALO ? true : false;
        if (typeof symbolizerConfig.ITALIC != "undefined") symbolizer.italic = symbolizerConfig.ITALIC ? true : false;
        if (typeof symbolizerConfig.SIZE != "undefined") symbolizer.size = symbolizerConfig.SIZE;
        if (typeof symbolizerConfig.STROKE_ALPHA != "undefined") symbolizer.strokeAlpha = symbolizerConfig.STROKE_ALPHA;
        if (typeof symbolizerConfig.STROKE_COLOR != "undefined") symbolizer.strokeColor = _createNewRGBA(symbolizerConfig.STROKE_COLOR);
        if (typeof symbolizerConfig.STROKE_STYLE != "undefined") symbolizer.strokeStyle = symbolizerConfig.STROKE_STYLE;
        if (typeof symbolizerConfig.STROKE_WIDTH != "undefined") symbolizer.strokeWidth = symbolizerConfig.STROKE_WIDTH;
        if (typeof symbolizerConfig.TEXT_ALIGN != "undefined") symbolizer.textAlign = symbolizerConfig.TEXT_ALIGN;
        if (typeof symbolizerConfig.TEXT_ALPHA != "undefined") symbolizer.textAlpha = symbolizerConfig.TEXT_ALPHA;
        if (typeof symbolizerConfig.UNDERLINED != "undefined") symbolizer.underlined = symbolizerConfig.UNDERLINED ? true : false;
        return symbolizer;
    };

    function _createStyleLabelProperties(labelsPropertiesConfig) {
        var styleLabelProperties = new StyleLabelProperties();
        if (typeof labelsPropertiesConfig.BACKGROUND_COLOR != "undefined") styleLabelProperties.backgroundColor = _createNewRGBA(labelsPropertiesConfig.BACKGROUND_COLOR);
        if (typeof labelsPropertiesConfig.BACKGROUND_IMAGE != "undefined") styleLabelProperties.backgroundImage = labelsPropertiesConfig.BACKGROUND_IMAGE;
        if (typeof labelsPropertiesConfig.BOLD != "undefined") styleLabelProperties.bold = labelsPropertiesConfig.BOLD ? true : false;
        if (typeof labelsPropertiesConfig.COLOR != "undefined") styleLabelProperties.color = _createNewRGBA(labelsPropertiesConfig.COLOR);
        if (typeof labelsPropertiesConfig.DROP_SHADOW_COLOR != "undefined") styleLabelProperties.dropShadowColor = _createNewRGBA(labelsPropertiesConfig.DROP_SHADOW_COLOR);
        if (typeof styleLabelProperties.FONT_NAME != "undefined" && typeof styleLabelProperties.FONT_FILE_SOURCE != "undefined") {
            FontLibrary.addFont(styleLabelProperties.FONT_NAME, styleLabelProperties.FONT_FILE_SOURCE);
            styleLabelProperties.fontName = labelsPropertiesConfig.FONT_NAME
        }
        if (typeof labelsPropertiesConfig.HALO_COLOR != "undefined") styleLabelProperties.haloColor = _createNewRGBA(labelsPropertiesConfig.HALO_COLOR);
        if (typeof labelsPropertiesConfig.HAS_BACKGROUND_COLOR != "undefined") styleLabelProperties.hasBackgroundColor = labelsPropertiesConfig.HAS_BACKGROUND_COLOR;
        if (typeof labelsPropertiesConfig.HAS_DROP_SHADOW_COLOR != "undefined") styleLabelProperties.hasDropShadowColor = labelsPropertiesConfig.HAS_DROP_SHADOW_COLOR;
        if (typeof labelsPropertiesConfig.HAS_HALO_COLOR != "undefined") styleLabelProperties.hasHaloColor = labelsPropertiesConfig.HAS_HALO_COLOR ? true : false;
        if (typeof labelsPropertiesConfig.LABELLING_POSITIONS_PREFERENCE != "undefined") styleLabelProperties.labellingPositionsPreference = labelsPropertiesConfig.LABELLING_POSITIONS_PREFERENCE;
        if (typeof labelsPropertiesConfig.LABEL_PRIORITY != "undefined") styleLabelProperties.labelPriority = labelsPropertiesConfig.LABEL_PRIORITY;
        if (typeof labelsPropertiesConfig.SIZE != "undefined") styleLabelProperties.size = labelsPropertiesConfig.SIZE;
        if (typeof labelsPropertiesConfig.UNDERLINE != "undefined") styleLabelProperties.underline = labelsPropertiesConfig.UNDERLINE ? true : false;
        if (typeof labelsPropertiesConfig.VISIBLE != "undefined") styleLabelProperties.visible = labelsPropertiesConfig.VISIBLE ? true : false;
        return styleLabelProperties;
    };

    export function _loadLayersData(layerConfigs) {
        var progressValue = 90 / layerConfigs.length;
        var percentage = 0;
        return Promise.all(_.map(layerConfigs, function(layerConfig, idx) {
            return queryLayer(layerConfig, typeof layerConfig.QUERY_EXPRESSION != "undefined" ? layerConfig.QUERY_EXPRESSION : null).then(function(response) {
                    percentage += progressValue;
                    $(".progress .progress-bar").width(percentage + "%");
                    return _createFeaturesAndDataRows(layerConfig, response);
            });
        }));
    };

    export function _loadCartovistaLayersData(layerConfigs) {
        return Promise.all(_.map(layerConfigs, function(layerConfig, idx) {
            return new Promise(function(resolve, reject) {
                if (!window.cartovista.getMap(C.MAP.ID) || !window.cartovista.getMap(C.MAP.ID).getLayer(layerConfig.LAYER_ID)) {
                    window.cartovista.addOneTimeEventListener(layerConfig.LAYER_ID + "_layerCreated", resolve.bind());
                } else {
                    resolve(window.cartovista.getMap(C.MAP.ID).getLayer(layerConfig.LAYER_ID));
                }
            }).then(function(event) {
                var layer = typeof event.source != "undefined" ? event.source.layer : event;
                //loader exists already
                if(layer.vectorSource.vectorLoaders.length == 1){
                    return layer.vectorSource.refresh();
                } else{
                    var projection = new Proj4Projection("EPSG:3857");
                    var loader = queryCartovistaLayer(projection, layerConfig);
                    return layer.addVectorLoader(loader, projection, null, null);
                }
           });
         }));
     };

     export function _loadEsriLayersData(layerConfigs) {
        return Promise.all(_.map(layerConfigs, function(layerConfig, idx) {
            return new Promise(function(resolve, reject) {
                if (!window.cartovista.getMap(C.MAP.ID) || !window.cartovista.getMap(C.MAP.ID).getLayer(layerConfig.LAYER_ID)) {
                    window.cartovista.addOneTimeEventListener(layerConfig.LAYER_ID + "_layerCreated", resolve.bind());
                } else {
                    resolve(window.cartovista.getMap(C.MAP.ID).getLayer(layerConfig.LAYER_ID));
                    }
                }).then(function(event) {
                var layer = typeof event.source != "undefined" ? event.source.layer : event;
                return new Promise(function(resolve, reject) {
                    //loader exists already
                    if(layer.vectorSource.vectorLoaders.length == 1){
                        resolve(layer.vectorSource.refresh());
                    } else{
                        var projection = new Proj4Projection("EPSG:3857");
                        var loader = queryEsriLayer(projection, layerConfig, typeof layerConfig.QUERY_EXPRESSION != "undefined" ? layerConfig.QUERY_EXPRESSION : null);
                        layer.addVectorLoader(loader, projection, null, null);
                        layer.addOneTimeEventListener(layer.EVENTS.FEATURES_ADDED, resolve.bind());
                    }
                });
            });
        }));
    };

    function _createFeaturesAndDataRows(layerConfig, layerData) {
        return new Promise(function(resolve, reject) {
            if (!window.cartovista.getMap(C.MAP.ID) || !window.cartovista.getMap(C.MAP.ID).getLayer(layerConfig.LAYER_ID)) {
                window.cartovista.addOneTimeEventListener(layerConfig.LAYER_ID + "_layerCreated", resolve.bind(layerData));
            } else {
                resolve(layerData);
            }
        }).then(function() {
            var map = window.cartovista.getMap(C.MAP.ID),
                layer = map.getLayer(layerConfig.LAYER_ID),
                features = createFeatures(layerConfig, layerData.features),
                dataTable = layer.getDataTable(layerConfig.DATATABLE_ID),
                dataRows = createDataRows(layerConfig, layerData.features, _.map(features, "id"));
            layer.addFeatures(features);
            dataTable.addDataRows(dataRows);
            if (layerConfig.LAYER_PROPERTIES.CLUSTERING_ENABLED) {
                layer.vectorSource.clusteringAlgorithm = new ClusterAlgorithmExtend(map, layerConfig.LAYER_PROPERTIES.CLUSTER_SIZE, layer, dataTable.getDataColumns(layerConfig.LAYER_PROPERTIES.CLUSTER_GROUP_BY_DATACOLUMN)[0]);
            }
            window.cartovista.dispatchEvent(new DBxEvent(layerConfig.LAYER_ID + "_featuresCreated", {"layer": layer, "dataTable": dataTable}));
            return layerData;
        });
    };

    export function createFeatures(layerConfig, featuresData) {
        switch(layerConfig.LAYER_TYPE) {
            case "POINT":
                return _createPointFeatures(layerConfig, featuresData);
            case "MULTIPOINT":
                return _createMultiPointFeatures(layerConfig, featuresData);
            case "POLYLINE":
                return _createPolylineFeatures(layerConfig, featuresData);
            case "POLYGON":
                return _createPolygonFeatures(layerConfig, featuresData);
            case "ANNOTATION":
                return _createAnnotationFeatures(layerConfig, featuresData);
            default:
                throw new Error("CvUtils._createFeatures() - layer: " + layerConfig.LAYER_ID + " - " + layerConfig.LAYER_TYPE + " invalid layerType");
        };
    };

    function _createPointFeatures(layerConfig, featuresData) {
        var map = window.cartovista.externalInterface.map;
        return _.map(featuresData, function(featureData) {
            var feature = new Feature(typeof featureData.attributes[layerConfig.LAYER_PROPERTIES.FEATURE_ID_DATACOLUMN] != "undefined" ? featureData.attributes[layerConfig.LAYER_PROPERTIES.FEATURE_ID_DATACOLUMN].toString() : featureData.attributes["GUID"]);
            feature.geometryType = "POINT";
            var pointGeometry = new PointGeometry(map.currentCoordinateSystem.projection);
            if (featureData.geometry) {
                var lineSegment = new LineSegment();
                lineSegment.coordinates = featureData.geometry;
            }
            pointGeometry.addPoint([lineSegment]);
            feature.addGeometries(pointGeometry);
            var style = _setFeatureStyle(layerConfig, featureData);
            if(typeof style.then == "function"){
                style.then(function(style){
                    feature.style = style;
                });
            } else{
                feature.style = style;
            }
            return feature;
        });
    };

    function _createMultiPointFeatures(layerConfig, featuresData) {
        throw new Error("CvUtils._createMultiPointFeatures() - function not implemented yet");
    };

    function _createPolylineFeatures(layerConfig, featuresData) {
        var map = window.cartovista.externalInterface.map;
        return _.map(featuresData, function(featureData) {
            var feature = new Feature(typeof featureData.attributes[layerConfig.LAYER_PROPERTIES.FEATURE_ID_DATACOLUMN] != "undefined" ? featureData.attributes[layerConfig.LAYER_PROPERTIES.FEATURE_ID_DATACOLUMN].toString() : featureData.attributes["GUID"]);
            feature.geometryType = "POLYLINE";
            var polylineGeometry = new PolylineGeometry(map.currentCoordinateSystem.projection);
            if (featureData.geometry) {
                for (var i=0, g=featureData.geometry.length; i<g ; i++) {
                    var path = [featureData.geometry[i][0], featureData.geometry[i][1]];
                    for (var j=2, l=featureData.geometry[i].length; j<l; j++) {
                        path.push(path[j-2] - featureData.geometry[i][j]);
                    }
                    var lineSegment = new LineSegment();
                    lineSegment.coordinates = layerConfig.USE_TYPED_ARRAY ? new Int32Array(path) : path;
                    polylineGeometry.addLineString([lineSegment]);
                }
            }
            feature.addGeometries(polylineGeometry);
            var style = _setFeatureStyle(layerConfig, featureData);
            if(typeof style.then == "function"){
                style.then(function(style){
                    feature.style = style;
                });
            } else{
                feature.style = style;
            }
            return feature;
        });
    };

    function _createPolygonFeatures(layerConfig, featuresData) {
        var map = window.cartovista.externalInterface.map;
        return _.map(featuresData, function(featureData) {
            var feature = new Feature(typeof featureData.attributes[layerConfig.LAYER_PROPERTIES.FEATURE_ID_DATACOLUMN] != "undefined" ? featureData.attributes[layerConfig.LAYER_PROPERTIES.FEATURE_ID_DATACOLUMN].toString() : featureData.attributes["GUID"]);
            feature.geometryType = "POLYGON";
            var polygonGeometry = new PolygonGeometry(map.currentCoordinateSystem.projection);
            if (featureData.geometry) {
                for (var i=0, g=featureData.geometry.length; i<g ; i++) {
                    var ring = [featureData.geometry[i][0], featureData.geometry[i][1]];
                    for (var j=2, l=featureData.geometry[i].length; j<l; j++) {
                        ring.push(ring[j-2] - featureData.geometry[i][j]);
                    }
                    var lineSegment = new LineSegment();
                    lineSegment.coordinates = layerConfig.USE_TYPED_ARRAY ? new Int32Array(ring) : ring;
                    polygonGeometry.addRing([lineSegment]);
                }
            }
            feature.addGeometries(polygonGeometry);
            var style = _setFeatureStyle(layerConfig, featureData);
            if(typeof style.then == "function"){
                style.then(function(style){
                    feature.style = style;
                });
            } else{
                feature.style = style;
            }
            return feature;
        });
    };

    function _createAnnotationFeatures(layerConfig, featuresData) {
        var map = window.cartovista.externalInterface.map;
        return _.map(featuresData, function(featureData) {
            var feature = new Feature(typeof featureData.attributes[layerConfig.LAYER_PROPERTIES.FEATURE_ID_DATACOLUMN] != "undefined" ? featureData.attributes[layerConfig.LAYER_PROPERTIES.FEATURE_ID_DATACOLUMN].toString() : featureData.attributes["GUID"]);
            feature.geometryType = "ANNOTATION";
            var annotationGeometry = new AnnotationGeometry(map.currentCoordinateSystem.projection);
            if (featureData.geometry) {
                for (var i=0; i < featureData.geometry.length; i++) {
                    var ring = [featureData.geometry[i][0], featureData.geometry[i][1]];
                    for (var j=2, l=featureData.geometry[i].length; j<l; j++) {
                        ring.push(ring[j-2] - featureData.geometry[i][j]);
                    }
                    var lineSegment = new LineSegment();
                    lineSegment.coordinates = ring;
                    annotationGeometry._addRing([lineSegment]);
                }
            }
            annotationGeometry.text = featureData.attributes["TEXT"];
            annotationGeometry.anchorCoordinates = [featureData.attributes["ANCHOR_X"], featureData.attributes["ANCHOR_Y"]];
            annotationGeometry.textPositionCoordinates = [featureData.attributes["TEXT_POSITION_X"], featureData.attributes["TEXT_POSITION_Y"]];
            annotationGeometry.mapScale = featureData.attributes["MAP_SCALE"];
            annotationGeometry.rotation = featureData.attributes["ROTATION"];
            feature.addGeometries(annotationGeometry);
            var style = _setFeatureStyle(layerConfig, featureData);
            if(typeof style.then == "function"){
                style.then(function(style){
                    feature.style = style;
                });
            } else{
                feature.style = style;
            }
            feature.labelVisible = false; //étiqettes invisible pour les annotations
            return feature;
        });
    };

    function _setFeatureStyle(layerConfig, featureData) {
        if (layerConfig.LAYER_PROPERTIES.UNIQUE_FEATURES_STYLES) {
            //unique styles for each features (styles not stored in layer.styles and style properties may come from featureData attributes)
            var featureStyle = createStyle(parseConfig(layerConfig.STYLES[0], featureData.attributes));
            featureStyle.styleLabelProperties = typeof layerConfig.STYLES[0].STYLE_LABEL_PROPERTIES != "undefined" ? _createStyleLabelProperties(layerConfig.STYLES[0].STYLE_LABEL_PROPERTIES) : featureStyle.styleLabelProperties;
            return featureStyle;
        } else {
            var map = window.cartovista.externalInterface.map;
            var layer = map.getLayer(typeof layerConfig.UNIQUE_LAYER_ID != "undefined" ? layerConfig.UNIQUE_LAYER_ID : layerConfig.LAYER_ID);
            var styles = layer.styles;
            if (typeof layerConfig.LAYER_PROPERTIES.STYLE_DATACOLUMN !== "undefined"){
                //style defined by a value and stored in layer.styles
                var style = _.find(styles, {"value" : featureData.attributes[layerConfig.LAYER_PROPERTIES.STYLE_DATACOLUMN]});
                if (typeof style != "undefined") {
                    return style;
                } else /*if(layerConfig.JOIN)*/{
                    return new Promise(function(resolve, reject) {
                        var dataTable = layer.getDataTable(layer.styleDataColumn.dataTable.id);
                        if(dataTable.loadingStatus == "NOT_LOADED"){
                            dataTable.addOneTimeEventListener(dataTable.EVENTS.DATA_TABLE_READY, function(){
                                layer.createDataQuery([layer.styleDataColumn], [featureData.attributes[layerConfig.LAYER_PROPERTIES.FEATURE_ID_DATACOLUMN]]).execute(resolve, this);
                            });
                        }else {
                            layer.createDataQuery([layer.styleDataColumn], [featureData.attributes[layerConfig.LAYER_PROPERTIES.FEATURE_ID_DATACOLUMN]]).execute(resolve, this);
                        }
                    }).then(function(dataQueryResult) {
                        style = _.find(styles, {"value" : dataQueryResult.values[layer.styleDataColumn.dataTable.id][layer.styleDataColumn.id][0]});
                        if(typeof style != "undefined"){
                            return style;
                        } else {
                            throw new Error("CvUtils._setFeatureStyle() - no style found for layer : " + layerConfig.LAYER_ID + " with value : " + featureData.attributes[layerConfig.LAYER_PROPERTIES.STYLE_DATACOLUMN]);
                        }
                    });
                } /*else {
                    throw new Error("CvUtils._setFeatureStyle() - no style found for layer : " + layerConfig.LAYER_ID + " with value : " + featureData.attributes[layerConfig.LAYER_PROPERTIES.STYLE_DATACOLUMN]);
                }*/
            } else {
                //style properties defined in layerConfig and stored in layer.styles
                var style = _.find(styles, {"id" : layerConfig.STYLES[0].ID});
                if (typeof style != "undefined") {
                    return style;
                } else {
                    throw new Error("CvUtils._setFeatureStyle() - no style found for layer : " + layerConfig.LAYER_ID + " with id : " + layerConfig.STYLES[0].ID);
                }
            }
        }
    };

    export function createDataRows(layerConfig, featuresData, linkingIds) {
        return _.map(featuresData, function(featureData, idx) {
            var values = _.map(parseConfig(layerConfig.FIELDS, featureData.attributes), function(fieldConfig) {
                switch(fieldConfig.DATA_TYPE) {
                    case "NUMBER":
                        return fieldConfig.VALUE ? parseFloat(fieldConfig.VALUE) : fieldConfig.VALUE;
                    case "DATE_TIME":
                    case "STRING":
                        return fieldConfig.VALUE ? fieldConfig.VALUE.toString() : fieldConfig.VALUE;
                    case "IMAGE_URL":
                    case "UNKNOWN":
                        return fieldConfig.VALUE;
                    default:
                        throw new Error("CvUtils._createDataRows() - fieldConfig.DATE_TYPE : " + fieldConfig.DATA_TYPE + " is invalid");
                }
            });
            return new DataRow(linkingIds[idx], values);
        });
    };

    export function createThemeSetElement(themeSetElementConfig) {
        switch (themeSetElementConfig.TYPE) {
            case ("ThemeSetGroup"):
                return _createThemeSetGroup(themeSetElementConfig);
            case ("ThemeSet"):
            case ("FlowThemeSet"):
                return _createThemeSet(themeSetElementConfig);
            default:
                throw new Error("CvUtils._createThemeSetElement() - themeSetElementConfig.TYPE : " + themeSetElementConfig.TYPE + " is invalid");
        };
    };

    function _createThemeSetGroup(themeSetElementConfig) {
        var map = window.cartovista.externalInterface.map;
        var themeSetGroup = new ThemeSetGroup(themeSetElementConfig.ID);
        if (typeof themeSetElementConfig.TITLE != "undefined") themeSetGroup.title = themeSetElementConfig.TITLE;
        if (typeof themeSetElementConfig.THEMESETS_ELEMENTS != "undefined" && Array.isArray(themeSetElementConfig.THEMESETS_ELEMENTS)) {
            _.forEach(themeSetElementConfig.THEMESETS_ELEMENTS, function(themeSetElementConfig) {
                var themeSetElement = createThemeSetElement(themeSetElementConfig);
                themeSetGroup.addThemeSetElement(themeSetElement, typeof themeSetElementConfig.INDEX != "undefined" ? themeSetElementConfig.INDEX : null, false);
            });
        }
        return themeSetGroup;
    };

    //TODO Generic createThemeElement in ThemeSet
    function _createThemeSet(themeSetElementConfig) {
        var map = window.cartovista.externalInterface.map;
        var themeSet = themeSetElementConfig.TYPE == "FlowThemeSet" ? new FlowThemeSet(themeSetElementConfig.ID) : new ThemeSet(themeSetElementConfig.ID);
        if (typeof themeSetElementConfig.TITLE != "undefined") themeSet.title = themeSetElementConfig.TITLE;
        if (typeof themeSetElementConfig.SELECTED_DATAVIEW_LAYER != "undefined") themeSet.selectedDataViewLayer = map.getLayer(themeSetElementConfig.SELECTED_DATAVIEW_LAYER);
        if (typeof themeSetElementConfig.SELECTED_SEARCH_LAYER != "undefined") themeSet.selectedSearchLayer = map.getLayer(themeSetElementConfig.SELECTED_SEARCH_LAYER);
        if (typeof themeSetElementConfig.THEMESET_MODE != "undefined") themeSet.themeSetMode = themeSetElementConfig.THEMESET_MODE;
        //flowthemeset properties
        if (typeof themeSetElementConfig.REFERENCE_LAYER_ID != "undefined") themeSet._referenceLayer = map.getLayer(themeSetElementConfig.REFERENCE_LAYER_ID);
        if (typeof themeSetElementConfig.FLOW_DATA_FILE_PATH != "undefined") themeSet._flowDataFilePath = themeSetElementConfig.FLOW_DATA_FILE_PATH;
        if (typeof themeSetElementConfig.ARRAY_FIELD != "undefined") themeSet._arrayField = themeSetElementConfig.ARRAY_FIELD;
        if (typeof themeSetElementConfig.ORIGIN_FEATURE_ID_FIELD != "undefined") themeSet._originFeatureIdField = themeSetElementConfig.ORIGIN_FEATURE_ID_FIELD;
        if (typeof themeSetElementConfig.ORIGIN_FEATURE_NAME_FIELD != "undefined") themeSet._originFeatureNameField = themeSetElementConfig.ORIGIN_FEATURE_NAME_FIELD;
        if (typeof themeSetElementConfig.DESTINATION_FEATURE_ID_FIELD != "undefined") themeSet._destinationFeatureIdField = themeSetElementConfig.DESTINATION_FEATURE_ID_FIELD;
        if (typeof themeSetElementConfig.DESTINATION_FEATURE_NAME_FIELD != "undefined") themeSet._destinationFeatureNameField = themeSetElementConfig.DESTINATION_FEATURE_NAME_FIELD;
        if (typeof themeSetElementConfig.FEATURE_VALUE_FIELD != "undefined") themeSet._featureValueField = themeSetElementConfig.FEATURE_VALUE_FIELD;
        if (typeof themeSetElementConfig.DEFAULT_FLOW_FEATURE_ID != "undefined") themeSet._defaultFlowFeatureId = themeSetElementConfig.DEFAULT_FLOW_FEATURE_ID;
        //update themeSetMaPSettings with current layer settings
        _.forEach(map.layers, function(layer) {
            themeSet.themeSetMapSettings.updateThemeSetLayerSettings(layer);
        });
        if (typeof themeSetElementConfig.THEMESET_MAP_SETTINGS != "undefined") {
            //edit themeSetLayerSettings as defined in themeSetElementConfig
            _.forEach(themeSetElementConfig.THEMESET_MAP_SETTINGS.LAYERS_SETTINGS, function(layerSettingsConfig) {
                var layer = map.getLayer(layerSettingsConfig.LAYER_ID);
                var layerSettings = themeSet.themeSetMapSettings.getThemeSetLayerSettings(layer);
                if (typeof layerSettingsConfig.ALPHA != "undefined") layerSettings.alpha = layerSettingsConfig.ALPHA;
                if (typeof layerSettingsConfig.CLUSTERING_ACTIVATED != "undefined") layerSettings.clusteringActivated = layerSettingsConfig.CLUSTERING_ACTIVATED;
                if (typeof layerSettingsConfig.LABEL_VISIBLE != "undefined") layerSettings.labelVisible = layerSettingsConfig.LABEL_VISIBLE;
                if (typeof layerSettingsConfig.VISIBLE != "undefined") layerSettings.visible = layerSettingsConfig.VISIBLE;
                if (typeof layerSettingsConfig.THEMESET_STYLE_SETTINGS != "undefined") {
                    _.forEach(layerSettingsConfig.THEMESET_STYLE_SETTINGS, function(styleSettingsConfig) {
                        var styleSettings = layerSettings.getThemeSetStyleSettings(layer.getStyle(styleSettingsConfig.STYLE_ID));
                        if (typeof styleSettingsConfig.VISIBLE != "undefined") styleSettings.visible = styleSettingsConfig.VISIBLE;
                    });
                }
            });
        }
        if (typeof themeSetElementConfig.THEMESET_DATA_FILTER_SETTINGS != "undefined") {
            themeSet.themeSetDataFilterSettings._map = map;
            //create themeSet filterDataColumns
            _.forEach(themeSetElementConfig.THEMESET_DATA_FILTER_SETTINGS.FILTER_DATA_COLUMNS_SETTINGS, function(filterDataColumnConfig) {
                var filterDataColumn = new FilterDataColumn();
                filterDataColumn.interactiveLayerId = filterDataColumnConfig.LAYER_ID;
                filterDataColumn.dataTableId = filterDataColumnConfig.DATATABLE_ID;
                filterDataColumn.dataColumnId = filterDataColumnConfig.DATACOLUMN_ID;
                filterDataColumn.filterLogic = typeof filterDataColumnConfig.FILTER_LOGIC != "undefined" ? filterDataColumnConfig.FILTER_LOGIC : filterDataColumn.filterLogic;
                filterDataColumn.dataFilters = _.map(filterDataColumnConfig.DATA_FILTERS, function(dataFilterConfig) {
                    switch (dataFilterConfig.TYPE) {
                        case ("StringFilter"):
                            return new StringFilter(dataFilterConfig.FILTER_OPERATOR, dataFilterConfig.VALUE);
                        case ("NumericFilter"):
                            return new NumericFilter(dataFilterConfig.FILTER_OPERATOR, dataFilterConfig.VALUE);
                        default:
                            throw new Error("CvUtils._createThemeSet - dataFilterConfig.TYPE : " + dataFilterConfig.TYPE + " is invalid.");
                    }
                });
                themeSet.themeSetDataFilterSettings.filterDataColumns.push(filterDataColumn);
            });
        }
        if (typeof themeSetElementConfig.THEMES != "undefined") {
            //create themes inside themeSetElementConfig
            _.forEach(themeSetElementConfig.THEMES, function(themeConfig) {
                var themeLayer = map.getLayer(themeConfig.LAYER_ID);
                if (themeConfig.TYPE != "HeatmapTheme"){
                    var dataTable = themeLayer.getDataTable(themeConfig.DATATABLE_ID);
                }
                switch (themeConfig.TYPE) {
                    case "ThemeByIndividualValues":
                        var themeElement = _createThemeByIndividualValues(themeConfig, dataTable.getDataColumns(themeConfig.DATACOLUMN_ID)[0], map.defaultThematicSettings);
                        var styleTheme = themeSet.addStyleThemeElement(themeElement, themeLayer);
                        break;
                    case "ThemeByRangesOfValues":
                        var themeElement = _createThemeByRangesOfValues(themeLayer, themeConfig, dataTable ? dataTable.getDataColumns(themeConfig.DATACOLUMN_ID)[0] : null, map.defaultThematicSettings);
                        var styleTheme = themeSet.addStyleThemeElement(themeElement, themeLayer);
                        if (typeof themeConfig.DEFAULT_COLOR != "undefined") styleTheme.defaultColor = new RGBA(themeConfig.DEFAULT_COLOR);
                        if (themeSetElementConfig.TYPE == "FlowThemeSet" && themeSet._referenceLayer == styleTheme.interactiveLayer){
                            themeSet.styleTheme = styleTheme.clone();
                            themeSet.removeTheme(styleTheme);
                        }
                        break;
                    case "ThemeByGradientOfValues":
                        var themeElement = _createThemeByGradientOfValues(themeConfig, dataTable.getDataColumns(themeConfig.DATACOLUMN_ID)[0], map.defaultThematicSettings);
                        var styleTheme = themeSet.addStyleThemeElement(themeElement, themeLayer);
                        if (typeof themeConfig.DEFAULT_COLOR != "undefined") styleTheme.defaultColor = new RGBA(themeConfig.DEFAULT_COLOR);
                        break;
                    case "PieChartOverlayTheme":
                        var themeElement = _createPieChartOverlayTheme(themeLayer, dataTable.getDataColumns(themeConfig.DATACOLUMNS_IDS), themeConfig, map.defaultThematicSettings);
                        var styleTheme = themeSet.addChartThemeElement(themeElement, themeLayer);
                        break;
                    case "BarChartOverlayTheme":
                        var themeElement = _createBarChartOverlayTheme(themeLayer, dataTable.getDataColumns(themeConfig.DATACOLUMNS_IDS), themeConfig, map.defaultThematicSettings);
                        var styleTheme = themeSet.addChartThemeElement(themeElement, themeLayer);
                        break;
                    case "SymbolByRangesOfValuesOverlayTheme":
                        var themeElement = _createThemeByRangesOfValues(themeLayer, themeConfig, dataTable.getDataColumns(themeConfig.DATACOLUMN_ID)[0], map.defaultThematicSettings);
                        var styleTheme = themeSet.addSymbolOverlayThemeElement(themeElement, themeLayer, map);
                        break;
                    case "SymbolByIndividualValuesOverlayTheme":
                        var themeElement = _createThemeByIndividualValues(themeConfig, dataTable.getDataColumns(themeConfig.DATACOLUMN_ID)[0], map.defaultThematicSettings);
                        var styleTheme = themeSet.addSymbolOverlayThemeElement(themeElement, themeLayer, map);
                        if (typeof themeConfig.DEFAULT_SYMBOL != "undefined") styleTheme.defaultSymbol = themeConfig.DEFAULT_SYMBOL;
                        if (typeof themeConfig.DEFAULT_SIZE != "undefined") styleTheme.defaultSize = themeConfig.DEFAULT_SIZE;
                        break;
                    case "HeatmapTheme":
                        var themeElement = _createHeatmapTheme(themeLayer, map, themeConfig);
                        var styleTheme = themeSet.addHeatMapThemeElement(themeElement, themeLayer);
                        break;
                    default:
                        throw new Error("CvUtils._createThemeSet - themeConfig.TYPE : " + themeConfig.TYPE + " is invalid.");
                }
            });
        }
        return themeSet;
    };

    function _createHeatmapTheme(themeLayer, map, themeConfig) {
        var themeElement = new HeatMapTheme(themeLayer, map);
        if (typeof themeConfig.DATACOLUMN_ID != "undefined") {
            var dataTable = themeLayer.getDataTable(themeConfig.DATATABLE_ID);
            themeElement.dataColumn = dataTable.getDataColumns(themeConfig.DATACOLUMN_ID)[0];
        }
        if (typeof themeConfig.FEATURES_VISIBILITY != "undefined") themeElement.featuresVisibility = themeConfig.FEATURES_VISIBILITY;
        if (typeof themeConfig.ALPHA != "undefined") themeElement.alpha = themeConfig.ALPHA;
        if (typeof themeConfig.PALETTE != "undefined") themeElement.heatMapPalette = themeConfig.PALETTE;
        if (typeof themeConfig.LEGEND_TEXT != "undefined") themeElement.legendText = themeConfig.LEGEND_TEXT;
        var radiusUnits = typeof themeConfig.RADIUS_UNITS != "undefined" ? (themeConfig.RADIUS_UNITS == "pixels" ? true : false) : true;
        if (typeof themeConfig.RADIUS != "undefined") themeElement.setRadius(themeConfig.RADIUS, radiusUnits)
        return themeElement;
    }

    function _createThemeByGradientOfValues(themeConfig, dataColumn, defaultThematicSettings) {
        var themeElement = new ThemeByGradientOfValues(themeConfig.REPRESENTATION_ENUM, dataColumn, defaultThematicSettings);
        //if (typeof themeConfig.AS_OVERLAY != "undefined") themeElement.asOverlay = themeConfig.AS_OVERLAY; //CV 7.4 ERROR
        if (typeof themeConfig.ENABLED != "undefined") themeElement.enabled = themeConfig.ENABLED;
        if (typeof themeConfig.GRADUATION_METHOD != "undefined") themeElement.graduationMethod = themeConfig.GRADUATION_METHOD;
        if (typeof themeConfig.MAX_VALUE != "undefined") themeElement.maxValue = themeConfig.MAX_VALUE;
        if (typeof themeConfig.MIN_VALUE != "undefined") themeElement.minValue = themeConfig.MIN_VALUE;
        if (typeof themeConfig.LEGEND_TEXT != "undefined") themeElement.legendText = themeConfig.LEGEND_TEXT;
        if (typeof themeConfig.PATTERN_COLOR != "undefined") themeElement.patternColor = themeConfig.PATTERN_COLOR;
        switch (themeConfig.REPRESENTATION_ENUM) {
            case "color":
                if (typeof themeConfig.MIN_REPRESENTATION != "undefined") themeElement.minRepresentation = new Color(_createNewRGBA(themeConfig.MIN_REPRESENTATION).ole);
                if (typeof themeConfig.MAX_REPRESENTATION != "undefined") themeElement.maxRepresentation = new Color(_createNewRGBA(themeConfig.MAX_REPRESENTATION).ole);
                break;
            case "size":
                if (typeof themeConfig.MIN_REPRESENTATION != "undefined") themeElement.minRepresentation = new Size(themeConfig.MIN_REPRESENTATION);
                if (typeof themeConfig.MAX_REPRESENTATION != "undefined") themeElement.maxRepresentation = new Size(themeConfig.MAX_REPRESENTATION);
                break;
        }
        return themeElement;
    };

    function _createBarChartOverlayTheme(layer, dataColumns, themeConfig, defaultThematicSettings){
        var themeElement = new BarChartOverlayTheme(layer, defaultThematicSettings);
        themeElement.dataColumns = dataColumns;
        if (typeof themeConfig.ALPHA != "undefined") themeElement.alpha = themeConfig.ALPHA;
        //if (typeof themeConfig.AS_OVERLAY != "undefined") themeElement.asOverlay = themeConfig.AS_OVERLAY; //CV 7.4 ERROR
        if (typeof themeConfig.BLEND_MODE != "undefined") themeElement.blendMode = themeConfig.BLEND_MODE;
        if (typeof themeConfig.DEFAULT_SIZE != "undefined") themeElement.defaultSize = themeConfig.DEFAULT_SIZE;
        if (typeof themeConfig.ENABLED != "undefined") themeElement.enabled = themeConfig.ENABLED;
        if (typeof themeConfig.GRADUATION_METHOD != "undefined") themeElement.graduationMethod = themeConfig.GRADUATION_METHOD;
        if (typeof themeConfig.INDIVIDUAL_VALUES != "undefined") themeElement.individualValues = themeConfig.INDIVIDUAL_VALUES;
        if (typeof themeConfig.IS_GRADUATED != "undefined") themeElement.isGraduated = themeConfig.IS_GRADUATED;
        if (typeof themeConfig.IS_STACKED != "undefined") themeElement.isStacked = themeConfig.IS_STACKED;
        if (typeof themeConfig.LEGEND_TEXT != "undefined") themeElement.legendText = themeConfig.LEGEND_TEXT;
        if (typeof themeConfig.MAX_SIZE != "undefined") themeElement.maxSize = themeConfig.MAX_SIZE;
        if (typeof themeConfig.MIN_SIZE != "undefined") themeElement.minSize = themeConfig.MIN_SIZE;
        if (typeof themeConfig.MAX_VALUE != "undefined") themeElement.maxValue = themeConfig.MAX_VALUE;
        if (typeof themeConfig.MIN_VALUE != "undefined") themeElement.minValue = themeConfig.MIN_VALUE;
        if(typeof themeConfig.SCHEME != "undefined"){
            var scheme = new IndividualValueScheme(themeConfig.SCHEME.ID);
            switch (themeConfig.REPRESENTATION_ENUM) {
                case "color":
                    _.forEach(themeConfig.SCHEME.SCHEME_ELEMENTS, function(schemeElementConfig) {
                        var rgba = new RGBA(schemeElementConfig.REPRESENTATION);
                        scheme.addIndividualValueSchemeElement(schemeElementConfig.VALUE, rgba.ole, schemeElementConfig.LEGEND_TEXT);
                    });
                    break;
                case "size" :
                case "symbol" :
                    _.forEach(themeConfig.SCHEME.SCHEME_ELEMENTS, function(schemeElementConfig) {
                        scheme.addIndividualValueSchemeElement(schemeElementConfig.VALUE, schemeElementConfig.REPRESENTATION, schemeElementConfig.LEGEND_TEXT);
                    });
                    break;
                default:
                    throw new Error("CvUtils._createBarChartOverlayTheme() - themeConfig.REPRESENTATION_ENUM : " + themeConfig.REPRESENTATION_ENUM + " is invalid");
            }
            themeElement.thematicScheme = scheme;
            ThematicSchemeManager.addThematicScheme(scheme);
        }
        return themeElement;
    };

    function _createPieChartOverlayTheme(layer, dataColumns, themeConfig, defaultThematicSettings){
        var themeElement = new PieChartOverlayTheme(layer, defaultThematicSettings);
        themeElement.dataColumns = dataColumns;
        if (typeof themeConfig.ALPHA != "undefined") themeElement.alpha = themeConfig.ALPHA;
        //if (typeof themeConfig.AS_OVERLAY != "undefined") themeElement.asOverlay = themeConfig.AS_OVERLAY; //CV 7.4 ERROR
        if (typeof themeConfig.BLEND_MODE != "undefined") themeElement.blendMode = themeConfig.BLEND_MODE;
        if (typeof themeConfig.DEFAULT_SIZE != "undefined") themeElement.defaultSize = themeConfig.DEFAULT_SIZE;
        if (typeof themeConfig.ENABLED != "undefined") themeElement.enabled = themeConfig.ENABLED;
        if (typeof themeConfig.GRADUATION_METHOD != "undefined") themeElement.graduationMethod = themeConfig.GRADUATION_METHOD;
        if (typeof themeConfig.INDIVIDUAL_VALUES != "undefined") themeElement.individualValues = themeConfig.INDIVIDUAL_VALUES;
        if (typeof themeConfig.IS_GRADUATED != "undefined") themeElement.isGraduated = themeConfig.IS_GRADUATED;
        if (typeof themeConfig.LEGEND_TEXT != "undefined") themeElement.legendText = themeConfig.LEGEND_TEXT;
        if (typeof themeConfig.MAX_SIZE != "undefined") themeElement.maxSize = themeConfig.MAX_SIZE;
        if (typeof themeConfig.MIN_SIZE != "undefined") themeElement.minSize = themeConfig.MIN_SIZE;
        if (typeof themeConfig.MAX_VALUE != "undefined") themeElement.maxValue = themeConfig.MAX_VALUE;
        if (typeof themeConfig.MIN_VALUE != "undefined") themeElement.minValue = themeConfig.MIN_VALUE;
        if(typeof themeConfig.SCHEME != "undefined"){
            var scheme = new IndividualValueScheme(themeConfig.SCHEME.ID);
            switch (themeConfig.REPRESENTATION_ENUM) {
                case "color":
                    _.forEach(themeConfig.SCHEME.SCHEME_ELEMENTS, function(schemeElementConfig) {
                        var rgba = new RGBA(schemeElementConfig.REPRESENTATION);
                        scheme.addIndividualValueSchemeElement(schemeElementConfig.VALUE, rgba.ole, schemeElementConfig.LEGEND_TEXT);
                    });
                    break;
                case "size" :
                case "symbol" :
                    _.forEach(themeConfig.SCHEME.SCHEME_ELEMENTS, function(schemeElementConfig) {
                        scheme.addIndividualValueSchemeElement(schemeElementConfig.VALUE, schemeElementConfig.REPRESENTATION, schemeElementConfig.LEGEND_TEXT);
                    });
                    break;
                default:
                    throw new Error("CvUtils._createPieChartOverlayTheme() - themeConfig.REPRESENTATION_ENUM : " + themeConfig.REPRESENTATION_ENUM + " is invalid");
            }
            themeElement.thematicScheme = scheme;
            ThematicSchemeManager.addThematicScheme(scheme);
        }
        return themeElement;
    };

    function _createThemeByRangesOfValues(layer, themeConfig, dataColumn, defaultThematicSettings) {
        var themeElement = new ThemeByRangesOfValues(themeConfig.REPRESENTATION_ENUM, dataColumn, defaultThematicSettings);
        themeElement.interactiveLayer = layer;
        //if (typeof themeConfig.AS_OVERLAY != "undefined") themeElement.asOverlay = themeConfig.AS_OVERLAY; //CV 7.4 ERROR
        if (typeof themeConfig.ENABLED != "undefined") themeElement.enabled = themeConfig.ENABLED;
        if (typeof themeConfig.LEGEND_TEXT != "undefined") themeElement.legendText = themeConfig.LEGEND_TEXT;
        if (typeof themeConfig.NUMBER_OF_RANGES != "undefined") themeElement.numberOfRanges = themeConfig.NUMBER_OF_RANGES;
        if (typeof themeConfig.PATTERN_COLOR != "undefined") themeElement.patternColor = themeConfig.PATTERN_COLOR;
        if (typeof themeConfig.REVERSE_RANGES != "undefined") themeElement.reverseRanges = themeConfig.REVERSE_RANGES;
        if (typeof themeConfig.REVERSE_REPRESENTATIONS != "undefined") themeElement.reverseRepresentations = themeConfig.REVERSE_REPRESENTATIONS;

        if (typeof themeConfig.RANGE_CALCULATION_METHOD != "undefined") themeElement.rangeCalculationMethodEnum = themeConfig.RANGE_CALCULATION_METHOD;
        if(typeof themeConfig.SCHEME != "undefined"){
            var scheme = new RangeScheme(themeConfig.SCHEME.ID);
            switch (themeConfig.REPRESENTATION_ENUM) {
                case "color":
                    if (typeof themeConfig.PALETTE != "undefined") themeElement.palette = new ColorPalette(themeConfig.PALETTE);
                    _.forEach(themeConfig.SCHEME.SCHEME_ELEMENTS, function(schemeElementConfig) {
                        var rgba = new RGBA(schemeElementConfig.REPRESENTATION);
                        scheme.addRangeSchemeElement(schemeElementConfig.MIN_VALUE, schemeElementConfig.MAX_VALUE, rgba.ole, schemeElementConfig.LEGEND_TEXT);
                    });
                    break;
                case "size" :
                     if (typeof themeConfig.PALETTE != "undefined") themeElement.palette = new SizePalette(themeConfig.PALETTE);
                     _.forEach(themeConfig.SCHEME.SCHEME_ELEMENTS, function(schemeElementConfig) {
                        var taille = schemeElementConfig.REPRESENTATION;
                        scheme.addRangeSchemeElement(schemeElementConfig.MIN_VALUE, schemeElementConfig.MAX_VALUE, taille, schemeElementConfig.LEGEND_TEXT);
                    });
                    break;
                case "symbol" :
                    if (typeof themeConfig.PALETTE != "undefined") themeElement.palette = new SymbolPalette(themeConfig.PALETTE);
                    _.forEach(themeConfig.SCHEME.SCHEME_ELEMENTS, function(schemeElementConfig) {
                        scheme.addRangeSchemeElement(schemeElementConfig.MIN_VALUE, schemeElementConfig.MAX_VALUE, schemeElementConfig.REPRESENTATION, schemeElementConfig.LEGEND_TEXT);
                    });
                    break;
                default:
                    throw new Error("CvUtils._createThemeByIndividualValues() - themeConfig.REPRESENTATION_ENUM : " + themeConfig.REPRESENTATION_ENUM + " is invalid");
            }
            themeElement.thematicScheme = scheme;
            ThematicSchemeManager.addThematicScheme(scheme);
        } else{
            switch (themeConfig.REPRESENTATION_ENUM) {
                case "color":
                    if (typeof themeConfig.PALETTE != "undefined") themeElement.palette = new PaletteFactory().getColorPalette(themeConfig.PALETTE);
                    break;
                case "size" :
                    if (typeof themeConfig.PALETTE != "undefined") themeElement.palette = new PaletteFactory().getSizePalette(themeConfig.PALETTE, layer.layerType, themeConfig.AS_OVERLAY);
                    break;
                case "symbol" :
                    if (typeof themeConfig.PALETTE != "undefined") themeElement.palette = new PaletteFactory().getSymbolPalette(themeConfig.PALETTE);
                    break;
                default:
                    throw new Error("CvUtils._createThemeByIndividualValues() - themeConfig.REPRESENTATION_ENUM : " + themeConfig.REPRESENTATION_ENUM + " is invalid");
            }
        }
        return themeElement;
    };

    function _createThemeByIndividualValues(themeConfig, dataColumn, defaultThematicSettings) {
        var themeElement = new ThemeByIndividualValues(themeConfig.REPRESENTATION_ENUM, dataColumn, defaultThematicSettings);
        //if (typeof themeConfig.AS_OVERLAY != "undefined") themeElement.asOverlay = themeConfig.AS_OVERLAY; //CV 7.4 ERROR
        if (typeof themeConfig.ENABLED != "undefined") themeElement.enabled = themeConfig.ENABLED;
        if (typeof themeConfig.LEGEND_TEXT != "undefined") themeElement.legendText = themeConfig.LEGEND_TEXT;
        if (typeof themeConfig.PATTERN_COLOR != "undefined") themeElement.patternColor = themeConfig.PATTERN_COLOR;
        if (typeof themeConfig.SHOW_INDIVIDUAL_VALES_WITH_ZERO_COUNT != "undefined") themeElement.showIndividualValuesWithZeroCount = themeConfig.SHOW_INDIVIDUAL_VALES_WITH_ZERO_COUNT;
        if(typeof themeConfig.SCHEME != "undefined"){
            var scheme = new IndividualValueScheme(themeConfig.SCHEME.ID);
            switch (themeConfig.REPRESENTATION_ENUM) {
                case "color":
                    _.forEach(themeConfig.SCHEME.SCHEME_ELEMENTS, function(schemeElementConfig) {
                        var rgba = new RGBA(schemeElementConfig.REPRESENTATION);
                        scheme.addIndividualValueSchemeElement(schemeElementConfig.VALUE, rgba.ole, schemeElementConfig.LEGEND_TEXT);
                    });
                    break;
                case "size" :
                case "symbol" :
                    _.forEach(themeConfig.SCHEME.SCHEME_ELEMENTS, function(schemeElementConfig) {
                        scheme.addIndividualValueSchemeElement(schemeElementConfig.VALUE, schemeElementConfig.REPRESENTATION, schemeElementConfig.LEGEND_TEXT);
                    });
                    break;
                default:
                    throw new Error("CvUtils._createThemeByIndividualValues() - themeConfig.REPRESENTATION_ENUM : " + themeConfig.REPRESENTATION_ENUM + " is invalid");
            }
            themeElement.thematicScheme = scheme;
            ThematicSchemeManager.addThematicScheme(scheme);
        }
        return themeElement;
    };

    export function compactGeometry(geometry) {
        switch (geometry.geometryType) {
            case "POINT":
                return _compactPointGeometry(geometry);
            case "POLYLINE":
                return _compactPolylineGeometry(geometry);
            case "POLYGON":
            case "ANNOTATION":
                return _compactPolygoneGeometry(geometry);
            default:
                throw new Error("CvUtils._compactGeometry - geometry.geometryType : " + geometry.geometryType + " is invalid.");
        };
    };

    function _compactPointGeometry(geometry) {
        return geometry.coordinates[0][0].coordinates;
    };

    function _compactPolylineGeometry(geometry) {
        return _.map(geometry.coordinates, function(lineSegment) {
            var compactGeometry = [lineSegment[0].coordinates[0], lineSegment[0].coordinates[1]];
            for (var i=2, l=lineSegment[0].coordinates.length; i<l; i++) {
                compactGeometry.push(lineSegment[0].coordinates[i-2] - lineSegment[0].coordinates[i]);
            }
            return compactGeometry;
        });
    };

    function _compactPolygoneGeometry(geometry) {
        return _.map(geometry.coordinates, function(lineSegment) {
            var compactGeometry = [lineSegment[0].coordinates[0], lineSegment[0].coordinates[1]];
            for (var i=2, l=lineSegment[0].coordinates.length; i<l; i++) {
                compactGeometry.push(lineSegment[0].coordinates[i-2] - lineSegment[0].coordinates[i]);
            }
            return compactGeometry;
        });
    };

    //deprecated use _drawStyleIconCanvas instead
    export function drawPointSymbolCanvas(canvas, styleConfig) {
        console.warn("CvUtils._drawPointSymbolCanvas() - deprecated use _drawStyleIconCanvas instead");
        return Promise.all(_.map(styleConfig.SYMBOLIZERS, function(symbolizerConfig) {
            return new Promise(function(resolve, reject) {
                var font = FontLibrary.getFont(symbolizerConfig.FONT_NAME);
                if (!font || !font.ready) {
                    FontLibrary.addOneTimeEventListener(FontLibrary.EVENTS.FONT_READY + "_" + symbolizerConfig.FONT_NAME, resolve);
                } else {
                    resolve();
                }
            })
        })).then(function() {
            var style = createStyle(styleConfig);
            var context = canvas.getContext("2d");
            context.clearRect(0, 0, canvas.width, canvas.heigth);
            canvas.width = styleConfig.SYMBOLIZERS[0].SIZE*2;
            canvas.height = styleConfig.SYMBOLIZERS[0].SIZE*2;
            Renderer.drawPoint(canvas, canvas.width/2, canvas.height/2, style.symbolizers);
            Renderer.trimCanvas(canvas);
        });
    };

    //style parameter could be style or styleConfig
    export function drawStyleIconCanvas(canvas, style, graphicFilterEffects) {
        var style = style.toString() == "Style" ? style : createStyle(style);
        Renderer.drawStyleIcon(canvas, style.symbolizers, graphicFilterEffects);
        return canvas;
    };

    export function cloneLayer(srcLayer, linkingIds) {
        srcLayer._cloneUniqueId = srcLayer._cloneUniqueId ? srcLayer._cloneUniqueId+1 : 2;
        var dstLayer = new InteractiveLayer(srcLayer.id + "_" + srcLayer._cloneUniqueId);
        dstLayer.addFeatures(_cloneFeatures(srcLayer, linkingIds));
        var dstDataTables = _cloneDataTables(srcLayer, dstLayer, linkingIds);
        _.forEach(dstDataTables, function(dstDataTable) {
            if(!_.startsWith(dstDataTable.id, "AttributesDataTable_")){
                dstLayer.dataElementRoot.addDataElement(dstDataTable);
            }
        });
        _cloneLayerProperties(srcLayer, dstLayer);
        return dstLayer;
    };

    function _cloneFeatures(srcLayer, linkingIds) {
        var dstFeatures;
        srcLayer.getSimpleFeatures(linkingIds, function(result) {
            dstFeatures = _.map(result.features, function(srcFeature) {
                var dstFeature = srcFeature.clone(srcFeature.id);
                dstFeature.selected = false;
                return dstFeature;
            });
        }, this);
        return dstFeatures;
    };

    function _cloneDataTables(srcLayer, dstLayer, linkingIds) {
        return _.map(srcLayer.dataElementRoot.dataElements, function(srcDataTable) {
            if(_.startsWith(srcDataTable.id, "AttributesDataTable_")){
                var dstDataTable = dstLayer.attributesDataTable;
            } else{
                var dstDataTable = new DataTable(srcDataTable.id + "_" + srcLayer._cloneUniqueId);
                dstDataTable.name = srcDataTable.name + "_" + + srcLayer._cloneUniqueId;
            }
            dstDataTable.addDataColumns(_cloneDataColumns(srcLayer, srcDataTable));
            dstDataTable.addDataRows(_cloneDataRows(srcDataTable, linkingIds));
            return dstDataTable;
        });
    };

    function _cloneDataColumns(srcLayer, srcDataTable) {
        return _.map(srcDataTable.dataColumns, function(srcDataColumn) {
            var dstDataColumn = new DataColumn(srcDataColumn.id + "_" + srcLayer._cloneUniqueId, srcDataColumn.dataType);
            dstDataColumn.decimalPlaces = srcDataColumn.decimalPlaces;
            dstDataColumn.description = srcDataColumn.description;
            dstDataColumn.mappable = srcDataColumn.mappable;
            dstDataColumn.name = srcDataColumn.name;
            dstDataColumn.timeStamp = srcDataColumn.timeStamp;
            dstDataColumn.timeStampAccuracy = srcDataColumn.timeStampAccuracy;
            dstDataColumn.units = srcDataColumn.units;
            dstDataColumn.unitsPlacement = srcDataColumn.unitsPlacement;
            return dstDataColumn;
        });
    };

    function _cloneDataRows(srcDataTable, linkingIds) {
        return _.reduce(srcDataTable._dataRows, function(dstDataRows, srcDataRow) {
            if (linkingIds.indexOf(srcDataRow._linkingId) > -1) {
                dstDataRows.push(srcDataRow.clone());
            }
            return dstDataRows;
        }, []);
    };

    function _cloneLayerProperties(srcLayer, dstLayer) {
        dstLayer.name = srcLayer.name + " " + srcLayer._cloneUniqueId;
        dstLayer.alpha = srcLayer.alpha;
        dstLayer.blendMode = srcLayer.blendMode;
        dstLayer.clusteringActivated = srcLayer.clusteringActivated;
        dstLayer.clusteringEnabled = srcLayer.clusteringEnabled;
        dstLayer.vectorSource.clusteringAlgorithm = srcLayer.vectorSource.clusteringAlgorithm ? new NonHierarchicalDistanceBasedClusteringAlgorithm(window.cartovista.externalInterface.map, srcLayer.vectorSource.clusteringAlgorithm._clusterSize) : null;
        dstLayer.clusteringForceClusterScale = srcLayer.clusteringForceClusterScale;
        dstLayer.wasClusteringEnabled = srcLayer.wasClusteringEnabled;
        dstLayer.dataTipDataColumns = _.map(srcLayer.dataTipDataColumns, function(srcDataColumn) {
            return dstLayer.getDataTable(srcDataColumn.dataTable.id + "_" + srcLayer._cloneUniqueId).getDataColumns(srcDataColumn.id + "_" + srcLayer._cloneUniqueId)[0];
        });
        dstLayer.dataTipDataColumnsDisplayMode = srcLayer.dataTipDataColumnsDisplayMode;
        dstLayer.dataViewDataColumns = _.map(srcLayer.dataViewDataColumns, function(srcDataColumn) {
            return dstLayer.getDataTable(srcDataColumn.dataTable.id + "_" + srcLayer._cloneUniqueId).getDataColumns(srcDataColumn.id + "_" + srcLayer._cloneUniqueId)[0];
        });
        dstLayer.dataViewDataColumnsDisplayMode = srcLayer.dataViewDataColumnsDisplayMode;
        dstLayer.featureIdDataColumn = srcLayer.featureIdDataColumn ? dstLayer.getDataTable(srcLayer.featureIdDataColumn.dataTable.id + "_" + srcLayer._cloneUniqueId).getDataColumns(srcLayer.featureIdDataColumn.id + "_" + srcLayer._cloneUniqueId)[0] : null;
        dstLayer.featureNameDataColumn = srcLayer.featureNameDataColumn ? dstLayer.getDataTable(srcLayer.featureNameDataColumn.dataTable.id + "_" + srcLayer._cloneUniqueId).getDataColumns(srcLayer.featureNameDataColumn.id + "_" + srcLayer._cloneUniqueId)[0] : null;
        dstLayer.hyperlinkDataColumn = srcLayer.hyperlinkDataColumn ? dstLayer.getDataTable(srcLayer.hyperlinkDataColumn.dataTable.id + "_" + srcLayer._cloneUniqueId).getDataColumns(srcLayer.hyperlinkDataColumn.id + "_" + srcLayer._cloneUniqueId)[0] : null;
        dstLayer.hyperlinkTargetType = srcLayer.hyperlinkTargetType;
        dstLayer.infoViewDataColumns = _.map(srcLayer.infoViewDataColumns, function(srcDataColumn) {
            return dstLayer.getDataTable(srcDataColumn.dataTable.id + "_" + srcLayer._cloneUniqueId).getDataColumns(srcDataColumn.id + "_" + srcLayer._cloneUniqueId)[0];
        });
        dstLayer.infoViewDataColumnsDisplayMode = srcLayer.infoViewDataColumnsDisplayMode;
        dstLayer.isVisibleInLegend = srcLayer.isVisibleInLegend;
        dstLayer.IsVisibleInLegendExtent = srcLayer.IsVisibleInLegendExtent;
        dstLayer.isZoomLayered = srcLayer.isZoomLayered;
        dstLayer.labelDataColumn = srcLayer.labelDataColumn ? dstLayer.getDataTable(srcLayer.labelDataColumn.dataTable.id + "_" + srcLayer._cloneUniqueId).getDataColumns(srcLayer.labelDataColumn.id + "_" + srcLayer._cloneUniqueId)[0] : null;
        dstLayer.layerLabelProperties = _cloneLayerLabelProperties(srcLayer.layerLabelProperties);
        dstLayer.layerType = srcLayer.layerType;
        dstLayer.MAX_FEATURES_FOR_ROLLOVER = srcLayer.MAX_FEATURES_FOR_ROLLOVER;
        dstLayer.maxRecordsForSelection = srcLayer.maxRecordsForSelection;
        dstLayer.maxScale = srcLayer.maxScale;
        dstLayer.minScale = srcLayer.minScale;
        dstLayer.metadata = srcLayer.metadata;
        dstLayer.searchableDataColumns = _.map(srcLayer.searchableDataColumns, function(srcDataColumn) {
            return dstLayer.getDataTable(srcDataColumn.dataTable.id + "_" + srcLayer._cloneUniqueId).getDataColumns(srcDataColumn.id + "_" + srcLayer._cloneUniqueId)[0];
        });
        dstLayer.searchRadius = srcLayer.searchRadius;
        dstLayer.showAttributesDataTable = srcLayer.showAttributesDataTable;
        dstLayer.showDataTips = srcLayer.showDataTips;
        dstLayer.showStylesInLayerControl = srcLayer.showStylesInLayerControl;
        dstLayer.styles = srcLayer.styles;
        dstLayer.styleDataColumn = srcLayer.styleDataColumn ? dstLayer.getDataTable(srcLayer.styleDataColumn.dataTable.id + "_" + srcLayer._cloneUniqueId).getDataColumns(srcLayer.styleDataColumn.id + "_" + srcLayer._cloneUniqueId)[0] : null;
        dstLayer.visible = srcLayer.visible;
        dstLayer.zoomOnFeatureScale = srcLayer.zoomOnFeatureScale;
    };

    function _cloneLayerLabelProperties(srcLayerLabelProperties) {
        var dstLayerLabelProperties = new LayerLabelProperties();
        dstLayerLabelProperties.allowLabelDuplicates = srcLayerLabelProperties.allowLabelDuplicates;
        dstLayerLabelProperties.allowLabelOverlap = srcLayerLabelProperties.allowLabelOverlap;
        dstLayerLabelProperties.isZoomLayered = srcLayerLabelProperties.isZoomLayered;
        dstLayerLabelProperties.labelType = srcLayerLabelProperties.labelType;
        dstLayerLabelProperties.leaderColor = srcLayerLabelProperties.leaderColor;
        dstLayerLabelProperties.leaderGridStep = srcLayerLabelProperties.leaderGridStep;
        dstLayerLabelProperties.leaderLines = srcLayerLabelProperties.leaderLines;
        dstLayerLabelProperties.leaderMaxDistance = srcLayerLabelProperties.leaderMaxDistance;
        dstLayerLabelProperties.maxScale = srcLayerLabelProperties.maxScale;
        dstLayerLabelProperties.minScale = srcLayerLabelProperties.minScale;
        dstLayerLabelProperties.offsetY = srcLayerLabelProperties.offsetY;
        dstLayerLabelProperties.position = srcLayerLabelProperties.position;
        dstLayerLabelProperties.priority = srcLayerLabelProperties.priority;
        dstLayerLabelProperties.rotation = srcLayerLabelProperties.rotation;
        dstLayerLabelProperties.visible = srcLayerLabelProperties.visible;
        return dstLayerLabelProperties;
    };
